import Enomy from "../../src/video/Enomy.png";
import CarSale from "../../src/video/CarSale.png";
import KYN from "../../src/video/KnowYourNeighborhood.png";
import MerryMeal from "../../src/video/MerryMeal.png";
import NextStore from "../../src/video/NextStore.gif"; // Add this line

export const projectData = [
  {
    name: "NextStore",
    image: NextStore,
    link: "https://github.com/ZinMyoWin/NextStore",
    type: "Personal Project",
    about:
      "A modern e-commerce platform with role-based access and real-time shopping cart features.",
  },
  {
    name: "Merry Meal",
    image: MerryMeal,
    link: "https://github.com/ZinMyoWin/MerryMeal",
    type: "School Project",
    about:
      "A charitable meal distribution system with role-based access and donation management.",
  },
  {
    name: "Know Your Neighborhood",
    image: KYN,
    link: "https://github.com/ZinMyoWin/Know_Your_Neighborhood",
    type: "School Project",
    about:
      "A location-based business directory with Google & Facebook authentication.",
  },
  {
    name: "Enomy Finances",
    image: Enomy,
    link: "https://github.com/ZinMyoWin/Enomy_Finance",
    type: "School Project",
    about:
      "A finance platform with real-time currency conversion, savings, and investment management.",
  },
  {
    name: "Used Car Sale Portal",
    image: CarSale,
    link: "https://github.com/ZinMyoWin/Used_Car_Portal",
    type: "School Project",
    about: "Marketplace enabling users to list, browse, and bid for used cars.",
  },
];
